import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatErrorMessage } from '../../utils';
import { notificationAlert } from '../notifications';
import { HeadcountChangesKey } from './headcountChanges.const';
import axios from 'axios';
import { apiEndpoints } from '../../constants/api';
import { HeadcountChange } from '../../types';
import { updateProjectedHeadcount } from '../account';
import { RootState } from '../store';

export const fetchHeadcountChanges = createAsyncThunk(
  `${HeadcountChangesKey}/fetchProjectedHeadcountChanges`,
  async (
    { projectIds }: { projectIds: string[]; activeId: string },
    thunkAPI,
  ): Promise<HeadcountChange[]> => {
    try {
      const { data } = await axios.get(
        `${apiEndpoints.fetchHeadcountChanges()}`,
        { params: { projectIds } },
      );

      return data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(
          formatErrorMessage(err, 'Fetching headcount changes has failed'),
          {
            variant: 'error',
          },
        ),
      );

      throw new Error(String(err));
    }
  },
);

export const saveHeadcountChanges = createAsyncThunk(
  `${HeadcountChangesKey}/saveHeadcountChanges`,
  async (
    { headcountChanges }: { headcountChanges: HeadcountChange[] },
    thunkAPI,
  ): Promise<HeadcountChange[]> => {
    try {
      const { data } = await axios.post(
        `${apiEndpoints.saveHeadcountChanges()}`,
        { headcountChanges },
      );

      return data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(
          formatErrorMessage(err, 'Saving headcount changes has failed'),
          {
            variant: 'error',
          },
        ),
      );

      const { headcountChanges } = thunkAPI.getState() as RootState;
      thunkAPI.dispatch(
        updateProjectedHeadcount(
          headcountChanges.previousHeadcountChanges ?? [],
        ),
      );
      throw new Error(String(err));
    }
  },
);
